import React from 'react';
import './ErrorPage.css';
import { useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
const ErrorComponent = () => {
  const navigate = useNavigate();
  const role = useSelector((state) => state.auth?.role);

  const handleNavigateHome = () => {
    if (role === 'Superadmin') {
      navigate('/admin-login');
    } else {
      navigate('/');
    }
  };
  return (
    <div className="error-page">
      <h1>Oops!</h1>
      <p>Sorry, an unexpected error has occurred.</p>
      <span>
        Go back to <button onClick={handleNavigateHome}>Home</button>
      </span>
    </div>
  );
};

export default ErrorComponent;
